export const A_PAIR_EVERY = 2000;

export const RINGS_FOR = 30_000;

export type Ringing = { about: string; startedAt: number; rung: number };

export type Stopped = "answered" | "declined" | "left" | "nobody answered";

export type Answered = { answered: boolean; declined: boolean; left: boolean };

export function began(about: string, at: number): Ringing {
  return { about, startedAt: at, rung: 0 };
}

export function whyItStopped(ring: Ringing, now: number, said: Answered): Stopped | null {
  if (said.answered) return "answered";
  if (said.declined) return "declined";
  if (said.left) return "left";
  if (now - ring.startedAt >= RINGS_FOR) return "nobody answered";
  return null;
}

export function nextPairAt(ring: Ringing): number {
  return ring.startedAt + ring.rung * A_PAIR_EVERY;
}

export function pairIsDue(ring: Ringing, now: number): boolean {
  return now >= nextPairAt(ring);
}

export function rang(ring: Ringing): Ringing {
  return { ...ring, rung: ring.rung + 1 };
}

export const PAIRS_AT_MOST = Math.ceil(RINGS_FOR / A_PAIR_EVERY);
